import { Instagram, Youtube, MessageCircle, Send } from "lucide-react";
import { useState } from "react";
import { SOCIALS } from "../data/mock";

/*
 * A sticky "engage" card that lives beside long-form pages
 * (essay + quote detail). Follow / Subscribe / WhatsApp + a small
 * suggestion form that opens WhatsApp pre-filled.
 */
export const EngageCard = () => {
  const [msg, setMsg] = useState("");

  const send = () => {
    const text = msg.trim() || "Hey Hunar, I wanted to say hi.";
    const url = `${SOCIALS.whatsapp}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <aside
      data-testid="engage-card"
      className="rounded-2xl p-6"
      style={{
        background: "var(--brand-cream-soft)",
        border: "1px solid var(--brand-line)",
      }}
    >
      <p className="text-[11px] font-semibold uppercase tracking-[0.25em]" style={{ color: "var(--brand-accent)" }}>
        Stay in touch
      </p>
      <p className="mt-2 text-lg font-bold leading-snug" style={{ color: "var(--brand-ink)" }}>
        Enjoyed this? Come hang out.
      </p>

      <div className="mt-5 space-y-2.5">
        <a
          href={SOCIALS.instagram}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="engage-instagram"
          className="group flex items-center gap-3 rounded-xl px-3.5 py-2.5 transition-transform duration-300 hover:-translate-y-0.5"
          style={{ background: "var(--brand-cream)", border: "1px solid var(--brand-line)" }}
        >
          <span
            className="w-8 h-8 rounded-full flex items-center justify-center text-white"
            style={{ background: "linear-gradient(135deg,#F58529 0%,#DD2A7B 45%,#8134AF 85%,#515BD4 100%)" }}
          >
            <Instagram size={15} strokeWidth={2} />
          </span>
          <div className="min-w-0">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em]" style={{ color: "var(--brand-muted)" }}>
              Instagram
            </p>
            <p className="text-sm font-semibold truncate" style={{ color: "var(--brand-ink)" }}>
              Follow @hunarsyal
            </p>
          </div>
        </a>
        <a
          href={SOCIALS.youtube}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="engage-youtube"
          className="group flex items-center gap-3 rounded-xl px-3.5 py-2.5 transition-transform duration-300 hover:-translate-y-0.5"
          style={{ background: "var(--brand-cream)", border: "1px solid var(--brand-line)" }}
        >
          <span className="w-8 h-8 rounded-full flex items-center justify-center text-white" style={{ background: "#FF0000" }}>
            <Youtube size={16} strokeWidth={2} />
          </span>
          <div className="min-w-0">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em]" style={{ color: "var(--brand-muted)" }}>
              YouTube
            </p>
            <p className="text-sm font-semibold truncate" style={{ color: "var(--brand-ink)" }}>
              Subscribe to Hunar Syal
            </p>
          </div>
        </a>
        <a
          href={SOCIALS.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="engage-whatsapp"
          className="group flex items-center gap-3 rounded-xl px-3.5 py-2.5 transition-transform duration-300 hover:-translate-y-0.5"
          style={{ background: "var(--brand-cream)", border: "1px solid var(--brand-line)" }}
        >
          <span className="w-8 h-8 rounded-full flex items-center justify-center text-white" style={{ background: "#25D366" }}>
            <MessageCircle size={15} strokeWidth={2} />
          </span>
          <div className="min-w-0">
            <p className="text-[11px] font-semibold uppercase tracking-[0.18em]" style={{ color: "var(--brand-muted)" }}>
              WhatsApp
            </p>
            <p className="text-sm font-semibold truncate" style={{ color: "var(--brand-ink)" }}>
              Chat with me
            </p>
          </div>
        </a>
      </div>

      <div className="mt-6 pt-5" style={{ borderTop: "1px solid var(--brand-line)" }}>
        <p className="text-[11px] font-semibold uppercase tracking-[0.25em] mb-2" style={{ color: "var(--brand-tertiary)" }}>
          What next?
        </p>
        <p className="text-sm mb-3" style={{ color: "var(--brand-muted)" }}>
          What should I write about next? Tell me.
        </p>
        <textarea
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
          data-testid="engage-suggest-input"
          rows={3}
          placeholder="I'd love an essay about..."
          className="w-full text-sm rounded-lg px-3 py-2.5 resize-none focus:outline-none focus:ring-2"
          style={{
            background: "var(--brand-cream)",
            border: "1px solid var(--brand-line)",
            color: "var(--brand-ink)",
          }}
        />
        <button
          onClick={send}
          data-testid="engage-suggest-send"
          className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-full btn-primary font-semibold px-5 py-2.5 text-sm"
        >
          <Send size={14} strokeWidth={2} />
          Send on WhatsApp
        </button>
      </div>
    </aside>
  );
};
